import { ComponentClass } from 'react';
export { ComponentClass };

import { LazyModule, LazyAction, createLazyComponent } from 'owa-bundling';
import { ExternalMessageEditorProps } from './components/OptionsEditor';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Options" */ './lazyIndex'));

export let lazyConfirmOptionNavigation = new LazyAction(lazyModule, m => m.confirmOptionNavigation);
export let OptionsEditor = createLazyComponent(lazyModule, m => m.OptionsEditor);

export { default as Option, CoreOption, LazyOption } from './store/schema/Option';
export { default as OptionCategory } from './store/schema/OptionCategory';
export { default as OptionSubCategory } from './store/schema/OptionSubCategory';
export { default as OptionComponentSettings } from './store/schema/OptionComponentSettings';
export { default as SubCategoryState } from './store/schema/SubCategoryState';
export {
    default as OptionQuickComponentSettings,
    OptionQuickComponentSettingsWithKey,
    OptionQuickCustomRenderComponentProps,
    OptionQuickToggleProps,
    OptionQuickCustomRenderProps,
    QuickSettingTooltip,
} from './store/schema/OptionQuickComponentSettings';
export { default as QuickSettingOrder } from './store/schema/QuickSettingOrder';

// Export service helpers
export {
    default as updateUserConfiguration,
    UserConfigurationSetting,
} from './services/updateUserConfiguration';
export {
    default as setMailboxMessageConfiguration,
} from './services/setMailboxMessageConfiguration';

// Export utils
export { default as getFallbackValueIfNull } from './utils/getFallbackValueIfNull';
export { default as updateSessionSettings } from './mutators/updateSessionSettings';
export { default as updateUserOptions } from './mutators/updateUserOptions';
export { default as isAnyOptionDirty } from './utils/isAnyOptionDirty';
export { default as hideSaveDiscardButtons } from './utils/hideSaveDiscardButtons';
export { default as shouldDisableSaveButton } from './utils/shouldDisableSaveButton';
export { createLazyOption } from './utils/createLazyOption';
export { tryLoadAllFullOptionsSync } from './utils/tryLoadAllFullOptionsSync';
export { ExternalMessageEditorProps };

// Export public actions
export { hideFullOptions } from './actions/publicActions';
